<template>
  <!-- TODO: need to clean this up -->
  <span class="product-shipping-duration">
    <template v-if="inStock">
      <fn-icon
        v-if="isPdp"
        :icon="stock.stockLevelStatus === 'inStock' ? 'full-dot' : 'half-dot'"
        size="xxs"
        token-color="color-general-text-status-positive-default"
      />
      <template v-if="Object.keys(storeAvailability).length">
        {{ $t('shipping.modes.store') }} {{ pdpAvailabilityText }}
      </template>
      <template v-if="!Object.keys(storeAvailability).length">
        <template v-if="defaultShippingDuration">
          <span>
            {{
              $t('shipping.status.default', {
                min: shippingInformation.deliveryTimeMin,
                max: shippingInformation.deliveryTimeMax,
              })
            }}

            <template v-if="marketplaceArticle">
              <fn-link
                static
                no-arrow
                underline
                icon
                large
                @click.prevent="$emit('openMarketplaceModal')"
              >
                {{
                  $t('shipping.marketplacePartnername', {
                    name: marketplacePartnerName,
                  })
                }}
              </fn-link></template
            ></span
          >
        </template>
        <template v-if="speditionShippingDuration">
          {{
            $t('shipping.status.spedition', {
              min: shippingInformation.deliveryTimeMin,
              max: shippingInformation.deliveryTimeMax,
            })
          }}
        </template>
        <template v-if="!defaultShippingDuration && !speditionShippingDuration && deliveryTimeInDays">
          {{ deliveryTimeInDays }}
        </template>
      </template>
    </template>
    <template v-else>
      <fn-availability-with-text
        v-if="showNonAvailableStatus"
        :text="nonAvailableStatusText"
      />
      <template v-else>
        <fn-icon
          v-if="!isWishlist"
          icon="crossed-dot"
          size="xxs"
          token-color="color-general-icons-neutral-higher"
        />
        {{ $t('shipping.modes.store') }} {{ $t('shipping.status.noResult') }}
      </template>
    </template>
  </span>
</template>

<script>
import {
  SHIPPING_DURATION_OUTOFSTOCK,
  SHIPPING_DURATION_REPLENISHMENT_EARLY,
  SHIPPING_DURATION_REPLENISHMENT_LATE,
  SHIPPING_DURATION_REPLENISHMENT_MEDIUM,
  SHIPPING_TYPE_DROPSHIP,
  SHIPPING_TYPE_FROZEN,
  SHIPPING_TYPE_PARCEL,
  SHIPPING_TYPE_SPEDITION,
} from '@/utils/shipping';
import { inStock } from '@/utils/stock';
import { formatDateStringToDDMMYYYY } from '@/utils/date';

export default {
  props: {
    shippingInformation: {
      type: Object,
      required: true,
    },
    stock: {
      type: Object,
      required: true,
    },
    deliveryTimeInDays: {
      type: String,
      default: '',
    },
    storeAvailability: {
      type: Object,
      default: () => ({}),
    },
    marketplaceArticle: {
      type: Boolean,
    },
    marketplacePartnerName: {
      type: String,
      default: '',
    },
    isPdp: {
      type: Boolean,
    },
    isWishlist: {
      type: Boolean,
    },
  },
  computed: {
    inStock() {
      return inStock(this.stock.stockLevelStatus);
    },

    defaultShippingDuration() {
      return (
        this.shippingInformation.detailedShippingInformation === SHIPPING_TYPE_PARCEL ||
        this.shippingInformation.detailedShippingInformation === SHIPPING_TYPE_DROPSHIP ||
        this.shippingInformation.detailedShippingInformation === SHIPPING_TYPE_FROZEN
      );
    },

    speditionShippingDuration() {
      return this.shippingInformation.detailedShippingInformation === SHIPPING_TYPE_SPEDITION;
    },

    earlyShippingDuration() {
      return this.shippingInformation.shippingDurationInfo === SHIPPING_DURATION_REPLENISHMENT_EARLY;
    },

    mediumShippingDuration() {
      return this.shippingInformation.shippingDurationInfo === SHIPPING_DURATION_REPLENISHMENT_MEDIUM;
    },

    lateShippingDuration() {
      return this.shippingInformation.shippingDurationInfo === SHIPPING_DURATION_REPLENISHMENT_LATE;
    },

    noShippingDuration() {
      return (
        this.shippingInformation.shippingDurationInfo === SHIPPING_DURATION_OUTOFSTOCK ||
        (this.stock.stockLevelStatus.toUpperCase() === SHIPPING_DURATION_OUTOFSTOCK && this.stock.soldInStore)
      );
    },

    replenishmentDate() {
      if (this.stock?.replenishmentDate) {
        return formatDateStringToDDMMYYYY(this.stock.replenishmentDate);
      }
    },

    pdpAvailabilityText() {
      const stockInfo = this.storeAvailability;

      if (stockInfo.stockLevelStatus === 'outOfStock') {
        return this.$t('product.availability.resultZero');
      }

      if (stockInfo.stockLevelStatus === 'lowStock') {
        return this.$t('product.availability.resultLow', { quantity: stockInfo.stockLevel });
      }

      if (stockInfo.stockLevelStatus === 'inStock') {
        return this.$t('product.availability.result', { quantity: stockInfo.stockLevel });
      }

      return '';
    },

    showNonAvailableStatus() {
      return (
        (this.earlyShippingDuration && this.replenishmentDate) ||
        this.mediumShippingDuration ||
        this.lateShippingDuration ||
        this.noShippingDuration
      );
    },

    nonAvailableStatusText() {
      if (this.earlyShippingDuration && this.replenishmentDate) {
        return this.$t('shipping.availabilityDate', {
          availabilityDate: this.replenishmentDate,
        });
      }
      if (this.mediumShippingDuration) {
        return this.$t('shipping.status.currentlyNotAvailable');
      }
      if (this.lateShippingDuration) {
        return this.$t('shipping.status.notAvailable');
      }
      if (this.noShippingDuration) {
        return Object.keys(this.storeAvailability).length
          ? `${this.$t('shipping.modes.store')} ${this.$t('shipping.status.outOfStock')}`
          : this.$t('shipping.status.outOfStock');
      }

      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.product-shipping-duration {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: math.div($pad, 2);
}
</style>
